import {
  NoteWrapper,
  RiskItem,
  RiskLabel,
  SuccessPlanCard,
  useSpContext,
} from "components/summary/success-plan";
import { SuccessPlanState } from "components/summary/success-plan/state/successPlan.types";
import moment from "moment-timezone";

type VidcastAssessmentSectionProps = {
  spState: SuccessPlanState;
};

const VidcastAssessmentSection = ({ spState }: VidcastAssessmentSectionProps) => {
  const { riskItems } = useSpContext();
  const { spData } = spState;
  const { vidCsmRisk, vidCsmRiskNote } = spData;
  const histories = spData.histories || [];

  const riskItem: RiskItem | undefined = riskItems.find((item) => item.value === vidCsmRisk);
  const filteredHistories = histories.filter(
    (history: any) => history.fieldName === "vidCsmRiskNote"
  );
  const noteHistories = filteredHistories.slice(1);
  const lastUpdatedOn =
    filteredHistories.length > 0
      ? moment(filteredHistories[0].lastModifiedDate)
          .tz("America/Los_Angeles")
          .format("YYYY-MM-DD HH:mm:ss PT")
      : "N/A";

  return (
    <SuccessPlanCard titleSlot="Vidcast Assessment">
      <RiskLabel riskItem={riskItem} />
      <NoteWrapper
        riskNote={vidCsmRiskNote}
        noteHistories={noteHistories}
        lastUpdatedOn={lastUpdatedOn}
      />
    </SuccessPlanCard>
  );
};

export default VidcastAssessmentSection;
